import { STAGING_STATUS } from "@/types/api";
import { Button, Chip, Stack } from "@mui/material";

export const STAGING_STATUS_OPTIONS = Object.entries(STAGING_STATUS).map(([value, label]) => ({
  value: Number(value),
  label,
}));

export const ALL_STAGING_STATUSES = STAGING_STATUS_OPTIONS.map((o) => o.value);

// Selecting every status and selecting none both mean "no status filter", so
// the selection is rebuilt in the canonical order rather than in click order:
// the server gets the same set either way and the query key stays stable, so
// toggling A then B does not refetch what toggling B then A already cached.
export function toggleStagingStatus(current: number[], value: number): number[] {
  return current.includes(value)
    ? current.filter((v) => v !== value)
    : ALL_STAGING_STATUSES.filter((v) => v === value || current.includes(v));
}

export interface StagingStatusFilterProps {
  statuses: number[];
  onChange: (next: number[]) => void;
}

// The status quick filters shared by the home Properties panel and the
// Stagings page. Both lists page server-side, so the selection travels with
// the request — filtering the page that came back would only ever narrow the
// rows the user is already looking at.
export function StagingStatusFilter({ statuses, onChange }: StagingStatusFilterProps) {
  return (
    <Stack
      direction="row"
      alignItems="center"
      flexWrap="wrap"
      sx={{ gap: 1 }}
    >
      {STAGING_STATUS_OPTIONS.map((opt) => {
        const selected = statuses.includes(opt.value);
        return (
          <Chip
            key={opt.value}
            label={opt.label}
            size="small"
            clickable
            color={selected ? "primary" : "default"}
            variant={selected ? "filled" : "outlined"}
            onClick={() => onChange(toggleStagingStatus(statuses, opt.value))}
            aria-pressed={selected}
          />
        );
      })}
      <Button
        size="small"
        onClick={() => onChange(ALL_STAGING_STATUSES)}
        disabled={statuses.length === ALL_STAGING_STATUSES.length}
        sx={{ textTransform: "none" }}
      >
        Select all
      </Button>
      <Button
        size="small"
        onClick={() => onChange([])}
        disabled={statuses.length === 0}
        sx={{ textTransform: "none" }}
      >
        Clear
      </Button>
    </Stack>
  );
}
